//////// GHG 2.1 EA
const twoOneSchema = {
  title: "2.1 Indirect Emissions from Purchased/Acquired Electricity",
  addAPI: "cat2_1AddEmissionActivityAPI",
  cat: "cat2_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Energy Supplier or Region",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Energy Type",
      optionsAPI: "importedElectricityEnergyTypeAPI",
      required: true,
    },
  ],
};

export default twoOneSchema;
